import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { LayoutService } from '../../services/layout/layout.service';
import { MenuItemComponent } from '../menu-item/menu-item.component';

@Component({
  selector: 'app-menu',
  imports: [
    MenuItemComponent,
    CommonModule
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent {
  private _layoutService = inject(LayoutService);

  public model: any[] = [];

  ngOnInit() {
    const itemsMenu: any[] = [
      {
        label: 'Academy', icon: 'pi pi-graduation-cap',
        items: [
          {
            label: 'Pestforce Academy',
            permissionKey: 'start',
            icon: 'pi pi-graduation-cap',
            routerLink: ['/']
          },
        ]
      },
    ];

    this.model = itemsMenu;
  }
}
